import type { ComponentPropsWithoutRef, ElementType, PropsWithChildren } from 'react';
import { useId } from 'react';

import { IconSystem } from '#icons/IconSystem';

import styles from './Banner.module.scss';

type Props = PropsWithChildren<{
	as?: ElementType;
	onClose?: () => void;
}> &
	ComponentPropsWithoutRef<ElementType>;

export function Banner({ as: As = 'div', children, onClose, className = '', ...rest }: Props) {
	const buttonId = useId();

	return (
		<As className={`${styles.wrapper} ${className}`} {...rest}>
			<section className={`${styles.content} body7`}>{children}</section>

			{!!onClose && (
				<button className={styles.closeButton} onClick={onClose} aria-label="Banner schließen" id={buttonId}>
					<IconSystem icon="close" variant="filled" aria-labelledby={buttonId} />
				</button>
			)}
		</As>
	);
}
